<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <PackingLabel
          v-if="transaction && !useBetaVersion"
          id="printMe"
          :data="transaction"
          :size="paperSize"
          :show-product="isShowProduct"
          :show-barcode="isShowBarcode"
          :show-insurance-fee="isShowInsuranceFee"
        />
        <PackingLabelPdf
          v-if="transaction && useBetaVersion"
          ref="pdfComponent"
          :data="transaction"
          :size="paperSize"
          :show-product="isShowProduct"
          :show-barcode="isShowBarcode"
          :show-insurance-fee="isShowInsuranceFee"
        />
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-action"
      >
        <b-card>
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Ukuran kertas"
                >
                  <b-form-radio-group
                    v-model="paperSize"
                    :options="optionsPaperSize"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    v-model="isShowProduct"
                    inline
                  >
                    Tampilkan produk
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col
                v-if="transaction.delivery_insurance_fee"
                cols="12"
              >
                <b-form-group>
                  <b-form-checkbox
                    v-model="isShowInsuranceFee"
                    inline
                  >
                    Tampilkan biaya Asuransi
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col
                v-if="transaction.delivery && transaction.delivery.airway_bill"
                cols="12"
              >
                <b-form-group>
                  <b-form-checkbox
                    v-model="isShowBarcode"
                    inline
                  >
                    Tampilkan barcode resi
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mb-75 mt-75"
                  block
                  @click="printSection"
                >
                  Cetak Label
                </b-button>

                <b-button
                  v-if="transaction"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="mb-75"
                  block
                  @click="downloadPDF"
                >
                  Download PDF
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  VBToggle,
  BFormGroup,
  BFormRadioGroup,
  BFormCheckbox,
  BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapState, mapActions } from 'vuex'
import print from 'vue-print-nb'
import PackingLabel from './PackingLabel.vue'
import PackingLabelPdf from './PackingLabelPdf.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    print,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormRadioGroup,
    BFormGroup,
    BFormCheckbox,
    BForm,

    PackingLabel,
    PackingLabelPdf,
  },
  data() {
    return {
      productList: [],
      isShowModalTandaiDikirim: false,
      paperSize: 'a6',
      optionsPaperSize: [
        {
          text: 'A4',
          value: 'a4',
        },
        {
          text: 'A6',
          value: 'a6',
        },
      ],
      config: false,
      isShowProduct: true,
      isShowInsuranceFee: true,
      isShowBarcode: true,
      useBetaVersion: true,
      optionsShowProduct: [
        {
          text: 'Tampilkan',
          value: true,
        },
        {
          text: 'Sembunyikan',
          value: false,
        },
      ],
      optionsShowBarcode: [
        {
          text: 'Tampilkan',
          value: true,
        },
        {
          text: 'Sembunyikan',
          value: false,
        },
      ],
    }
  },
  computed: {
    ...mapState('transaction', ['transaction']),
  },
  async created() {
    this.isPending = true
    await this.getDetailTransaction(this.$route.params.id)
    this.isPending = false
  },
  methods: {
    ...mapActions('transaction', ['getDetailTransaction']),
    printSection() {
      if (this.useBetaVersion) {
        // For PDF version, try iframe printing first, then direct PDF printing
        if (this.$refs.pdfComponent) {
          // Try iframe printing first (faster)
          this.$refs.pdfComponent.printPDFFromIframe()
        } else {
          window.print()
        }
      } else {
        // Original print functionality for regular HTML version
        window.print()
      }
    },

    async printPDF() {
      try {
        // Find the PDF iframe
        const iframe = document.querySelector('.pdf-viewer')
        if (!iframe || !iframe.src) {
          alert('PDF iframe not found or not loaded')
          // Fallback to regular print
          window.print()
          return
        }

        // Create a new window with the PDF URL for printing
        const pdfUrl = iframe.src.split('#')[0] // Remove any URL fragments
        const printWindow = window.open(pdfUrl, '_blank', 'width=800,height=600')

        if (printWindow) {
          // Wait for the PDF to load, then trigger print
          printWindow.onload = () => {
            setTimeout(() => {
              printWindow.print()
              // Close the window after printing (optional)
              printWindow.onafterprint = () => {
                printWindow.close()
              }
            }, 1000) // Give PDF time to render
          }
        } else {
          // If popup blocked, try alternative method
          this.downloadAndPrintPDF(pdfUrl)
        }
      } catch (error) {
        alert('Error printing PDF:', error)
        // Fallback to regular print
        window.print()
      }
    },

    async downloadAndPrintPDF(pdfUrl) {
      try {
        // Create a temporary link to trigger PDF download/print
        const link = document.createElement('a')
        link.href = pdfUrl
        link.target = '_blank'
        link.rel = 'noopener noreferrer'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        alert('Error downloading PDF:', error)
        window.print()
      }
    },

    downloadPDF() {
      if (this.useBetaVersion && this.$refs.pdfComponent) {
        this.$refs.pdfComponent.downloadPDF()
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  @page {
    size: A4;
    margin: 0;
  }

  @media print {
    @media print {
      @page { size: portrait }
    }
    // Global Styles
    html, body {
      width: 210mm;
      height: 297mm;
    }
    body {
      background-color: transparent !important;
    }
    nav.header-navbar {
      display: none;
    }
    .main-menu {
      display: none;
    }
    .header-navbar-shadow {
      display: none !important;
    }
    .content.app-content {
      margin-left: 0;
      padding-top: 2rem !important;
    }
    .content-header {
      display: none;
    }
    footer.footer {
      display: none;
    }
    .card {
      background-color: transparent;
      box-shadow: none;
    }
    .customizer-toggle {
      display: none !important;
    }

    .invoice-action {
      display: none;
    }

    // Hide the PDF container during print to use browser's print function
    .pdf-container {
      iframe {
        width: 100% !important;
        height: 100vh !important;
      }
    }
  }
</style>
